<template>
    <div>
        <div v-if="title">
            <van-cell class="title_cell" :title="title" :icon="icon" :style="titleStyle"/>
        </div>
        <van-swipe :autoplay="autoPlay" :show-indicators="true" style="padding: 10px 0px 15px 0px">
            <van-swipe-item v-for="(items, index) in hotDatas" :key="index" >
                <div>
                    <van-grid :column-num="3" :border="false" gutter="5">
                        <van-grid-item
                                v-for="(item, index) in items"
                                :key="index"
                        >
                            <div slot="default" @click="clickItem(item)">
<!--                                <Wp_image :url="item.imageInfo.imageList[0].url"></Wp_image>-->
                                <JdSkuInfoSimpleCard :sku-info="item" :img-gray="imgGray"></JdSkuInfoSimpleCard>
                            </div>

                        </van-grid-item>
                    </van-grid>
                </div>
            </van-swipe-item>

<!--            <div slot="indicator" :show-indicators="true">-->
<!--            </div>-->
        </van-swipe>
    </div>
</template>

<script>
    import Wp_image from "./Wp_image";
    import Wp_grid from "./Wp_grid";
    import JdSkuInfoSimpleCard from "./JdSkuInfoSimpleCard";
    export default {
        name: "Wp_jd_hot_sku_model",
        components: {JdSkuInfoSimpleCard, Wp_grid, Wp_image},
        props:{
            hotDatas:{type: Array},
            autoPlay:{type: Number, default: 5000},
            icon:{type: String, default: ""},
            title:{type: String, default: ""},
            titleStyle:{type: String, default: ""},
            imgGray:{type: Boolean, default: false}
        },
        created() {
        },

        methods:{
            clickItem(item){
                this.$emit("clickItem", item);
            }
        }
    }
</script>

<style scoped>
    /deep/ .van-grid-item .van-grid-item__content  {
        background-color: rgba(255, 255, 0, 0);
        padding: 0px;
    }

    .title_cell{
        padding: 0px 1px;
        background-color: rgba(0,0,0,0);
    }

    /deep/ .van-swipe__indicator{
        background-color: #1989fa;
        /*border: 1px solid #1989fa;*/
    }

    /deep/ .van-swipe__indicators{
        bottom: 5px;
    }
</style>